import {IApiModel} from './api-model.interface';
import {Role} from './role.model';
import {Position} from './position.model';

export class User implements IApiModel<User> {
    id: number;
    firstName: string;
    lastName: string;
    fullName: string;
    position: Position;
    email: string;
    phone: string;
    role: Role;
    currentRole: string;
    password: string;

    public constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }

    getName(): string {
        if (this.fullName) {
            return this.fullName;
        } else {
            return `${this.firstName} ${this.lastName}`;
        }
    }

    getApiModel(): any {
        return undefined;
    }

    setFromApiModel(apiModel: any): this {
        this.id = Number.parseInt(apiModel.id);
        this.firstName = apiModel.first_name;
        this.lastName = apiModel.last_name;
        this.fullName = apiModel.full_name;
        this.email = apiModel.email;
        this.role = apiModel.groups ? apiModel.groups[0] : '401';
        return this;
    }
}
